import { render, staticRenderFns } from "./BlogListPage.vue?vue&type=template&id=85f53b4e&"
import script from "./BlogListPage.vue?vue&type=script&lang=js&"
export * from "./BlogListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports